import { render } from "./DashboardCajero.vue?vue&type=template&id=60b62922"
import script from "./DashboardCajero.vue?vue&type=script&lang=js"
export * from "./DashboardCajero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__